/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jsmCustomerAuthenticationSettingsResource } from '@jira/router-resources__jsm-authentication-settings/src/jsmCustomerAuthenticationSettingsResource.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmAuthenticationSettingsRoute } from '@jira/router-routes__admin-pages-jsm-authentication-settings-routes/src/productsJsmAuthenticationSettingsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import AuthenticationSettings, {
	LazyAuthenticationSettings,
} from './ui/spa/admin-pages/jsm-authentication-settings/ui/index.tsx';

export const productsJsmAuthenticationSettingsRouteEntry: Route = createEntry(
	productsJsmAuthenticationSettingsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-authentication-settings',
		// eslint-disable-next-line no-restricted-syntax
		component: AuthenticationSettings,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			jsmCustomerAuthenticationSettingsResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyAuthenticationSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
